import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import ReturnsBarChart from './ReturnsBarChart';

const schema: JSONSchema7 = {
    title: 'Returns Bar Chart',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chartTitles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Data Key',
            default: '',
        },
        useSampleData: {
            type: 'boolean',
            title: 'Use Sample Data',
            default: '',
        },
        xLabels: {
            type: 'string',
            title: 'X-Axis Labels',
            default: '',
            description: 'Enter comma seperated values',
        },
        keys: {
            type: 'string',
            title: 'Keys to Map labels',
            default: '',
            description: 'Enter comma seperated values',
        },
        formatTo: {
            type: 'string',
            title: 'Format To',
            default: 'pctMax2',
            description: 'Enter format for converting series data',
        },
        dataLabelFormat: {
            type: 'string',
            title: 'Chart Labels Format',
            default: 'decMax1',
            description:
                'Enter format for chart labels, Note: This format will apply after series data format',
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        isStockChart: {
            type: 'boolean',
            title: 'Is stock chart',
            default: false,
        },
        ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.schema(),
        showDifferentZone: {
            type: 'boolean',
            title: 'Divide chart in zone',
            description: 'This option will show different zone on chart with diffrent color',
            default: false,
        },
        paletteId: {
            type: 'string',
            title: 'Palette ID',
            default: 'pieChartPalette',
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default: 'return (data) => { return data }',
                        },
                    },
                },
                {
                    properties: {
                        transformData: { enum: [false] },
                    },
                },
            ],
        },
        showDifferentZone: {
            oneOf: [
                {
                    properties: {
                        showDifferentZone: { enum: [true] },
                        zoneOptions: {
                            type: 'object',
                            properties: {
                                year: {
                                    type: 'string',
                                    title: 'Start zone till year',
                                    default: '2016',
                                    description: 'Zone from min date in data to this year',
                                },
                                color: {
                                    type: 'string',
                                    title: 'Color',
                                    default: '#b74a02',
                                    description: 'Color for the zone bar',
                                },
                            },
                        },
                    },
                },
                {
                    properties: {
                        showDifferentZone: { enum: [false] },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'paletteId',
            'chartTitles',
            'dataKey',
            'useSampleData',
            'xLabels',
            'keys',
            'formatTo',
            'dataLabelFormat',
            'isStockChart',
            'options',
            'showDifferentZone',
            'zoneOptions',
        ],
        'Transform Data': ['transformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    compoundReturnslabels: { 'ui:widget': 'checkboxes' },
    typeOfReturns: { 'ui:widget': 'radio' },
    styles: { 'ui:widget': 'CSSEditor' },
    functionToTransform: { 'ui:widget': 'JSEditor' },
    chartTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    paletteId: { 'ui:widget': 'PaletteSelect' },
    dataKey: { 'ui:widget': 'CustomTextInput' },
    useSampleData: { 'ui:widget': 'CustomCheckbox' },
    keys: { 'ui:widget': 'CustomTextInput' },
    xLabels: { 'ui:widget': 'CustomTextInput' },
    formatTo: { 'ui:widget': 'CustomTextInput' },
    dataLabelFormat: { 'ui:widget': 'CustomTextInput' },
    showDifferentZone: { 'ui:widget': 'CustomCheckbox' },
    isStockChart: { 'ui:widget': 'CustomTextInput' },
    ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.uiSchema,
};

const ReturnsBarChartWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: ReturnsBarChart,
    id: 'ReturnsBarChart',
    group: 'charts',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ReturnsBarChartWidget;
